import React from 'react';
import VyTooltip from '../../../common/VyTooltip';

interface Props {
  status: string;
}

const StatusIcon = ({ status }: Props) => {
  return (
    <div className="relative top-1 mr-4">
      {status === 'open' && (
        <VyTooltip title="Der Raum ist verfügbar">
          <div className="bg-[#48bb78] h-4 w-4">&nbsp;</div>
        </VyTooltip>
      )}
      {status === 'queue' && (
        <VyTooltip title="Der Raum ist aktuell belegt">
          <div className="bg-[#e53e3e] h-4 w-4">&nbsp;</div>
        </VyTooltip>
      )}
      {status === 'offline' && (
        <VyTooltip title="Der Raum ist aktuell offline">
          <div className="bg-gray-500 h-4 w-4">&nbsp;</div>
        </VyTooltip>
      )}
    </div>
  );
};

export default StatusIcon;
